//reducer is listening to every action that is sent
export default function productsReducer(state = [], action) {
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/products-reducer.js